import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: `${API_URL}/api/economies`,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('finance_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const economiesApi = {
  getAll: () => api.get('/'),
  create: (data) => api.post('/', data),
  remove: (id) => api.delete(`/${id}`),
};

export default economiesApi;
